import { useStyles } from 'components/desktop/_general/NutritionFactsLabel/NutritionFactsLabel.tss';

export type Value = {
	value: number;
	unit: string;
	percent?: number;
};

export type Values = {
	calories: Value;
	fatTotal: Value;
	fatSaturated: Value;
	fatTrans: Value;
	cholesterol: Value;
	sodium: Value;
	carbohydrateTotal: Value;
	fiberDietary: Value;
	sugarsTotal: Value;
	protein: Value;
	vitaminD: Value;
	calcium: Value;
	iron: Value;
	potassium: Value;
};

export interface Props {
	values: Values;
	servingSize: Value;
}

const NutritionFactsLabel = (props: Props) => {
	const { classes } = useStyles();

	const state: Values = {} as Values;
	for (const [key, value] of Object.entries(props.values)) {
		state[key as keyof Values] = {} as Value;
		state[key as keyof Values].value = Math.round(value.value);
		state[key as keyof Values].unit = value.unit;
		if (value.percent !== undefined) {
			state[key as keyof Values].percent = Math.round(value.percent);
		}
	}

	return (
		<div className={classes.label}>
			<div className={classes.title}>Nutrition Facts</div>
			<div className={classes.servingSize}>
				<div>Serving size</div>
				<div>
					{Math.round(props.servingSize.value)}
					{props.servingSize.unit}
				</div>
			</div>
			<div className={classes.amountPerServing}>Amount per serving</div>
			<div className={classes.caloriesContainer}>
				<div className={classes.calories}>Calories</div>
				<div className={classes.caloriesAmount}>{state.calories.value}</div>
			</div>
			<div className={classes.dailyValue}>% Daily Value *</div>

			<div className={classes.valuesCategory}>
				<div>
					<span className={classes.valuesBold}>Total Fat</span> {state.fatTotal.value}
					{state.fatTotal.unit}
				</div>
				<div className={classes.valuesBold}>{state.fatTotal.percent}%</div>
			</div>
			<div className={classes.valuesDetail}>
				<div>
					Saturated Fat {state.fatSaturated.value}
					{state.fatSaturated.unit}
				</div>
				<div className={classes.valuesBold}>{state.fatSaturated.percent}%</div>
			</div>
			<div className={classes.valuesDetail}>
				<div>
					<span className={classes.valuesItalic}>Trans</span> Fat {state.fatTrans.value}
					{state.fatTrans.unit}
				</div>
			</div>
			<div className={classes.valuesCategory}>
				<div>
					<span className={classes.valuesBold}>Cholesterol</span>{' '}
					{state.cholesterol.value}
					{state.cholesterol.unit}
				</div>
				<div className={classes.valuesBold}>{state.cholesterol.percent}%</div>
			</div>
			<div className={classes.valuesCategory}>
				<div>
					<span className={classes.valuesBold}>Sodium</span> {state.sodium.value}
					{state.sodium.unit}
				</div>
				<div className={classes.valuesBold}>{state.sodium.percent}%</div>
			</div>
			<div className={classes.valuesCategory}>
				<div>
					<span className={classes.valuesBold}>Total Carbohydrate</span>{' '}
					{state.carbohydrateTotal.value}
					{state.carbohydrateTotal.unit}
				</div>
				<div className={classes.valuesBold}>{state.carbohydrateTotal.percent}%</div>
			</div>
			<div className={classes.valuesDetail}>
				<div>
					Dietary Fiber {state.fiberDietary.value}
					{state.fiberDietary.unit}
				</div>
				<div className={classes.valuesBold}>{state.fiberDietary.percent}%</div>
			</div>
			<div className={classes.sugar}>
				<div>
					Total Sugars {state.sugarsTotal.value}
					{state.sugarsTotal.unit}
				</div>
			</div>
			<div className={classes.protein}>
				<div>
					<span className={classes.valuesBold}>Protein</span> {state.protein.value}
					{state.protein.unit}
				</div>
			</div>

			<div className={classes.valuesCategory}>
				<div>
					Vitamin D {state.vitaminD.value}
					{state.vitaminD.unit}
				</div>
				<div>{state.vitaminD.percent}%</div>
			</div>
			<div className={classes.valuesCategory}>
				<div>
					Calcium {state.calcium.value}
					{state.calcium.unit}
				</div>
				<div>{state.calcium.percent}%</div>
			</div>
			<div className={classes.valuesCategory}>
				<div>
					Iron {state.iron.value}
					{state.iron.unit}
				</div>
				<div>{state.iron.percent}%</div>
			</div>
			<div className={classes.potassium}>
				<div>
					Potassium {state.potassium.value}
					{state.potassium.unit}
				</div>
				<div>{state.potassium.percent}%</div>
			</div>

			<div className={classes.footnote}>
				<div>*</div>
				<div>
					The % Daily Value (DV) tells you how much a nutrient in
					<br />a serving of food contributes to a daily diet. 2,000 calories
					<br />a day is used for general nutrition advice.
				</div>
			</div>
		</div>
	);
};

export default NutritionFactsLabel;
